import styled from 'styled-components';

export const RecoStylingList = styled.div`
  @media ${({ theme }) => theme.media.smMax} {
  }
`;
